<template>
  <div class="background" @click.self.prevent="setNotification({})" v-if="notyfication.message">
    <div class="wrapper">
      <img src="./qr.svg" width="200px"/>
      <h2>{{ notyfication.header }}</h2>
      <p>{{ notyfication.message }}</p>
      <button @click="setNotification({})">{{ $t('notificationCloseButton') }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      notyfication: (state) => state.applicationStore.notyfication,
    }),
  },
  methods: {
    ...mapActions({
      setNotification: 'applicationStore/setNotification',
    }),
  },
};
</script>

<style scoped lang="scss">
  .background {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    background: rgba(10, 10, 10, 0.86);
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
  }
  .wrapper {
    min-height: 100vh;
    background: $background-light-color;
    width: 100vw;
    padding-top: 40px;
  }
  img {
    display: block;
    margin: 0 auto;
    background: #00000030;
    box-shadow: 0 0 4em #00000030;
    border-radius: 100%;
    padding: 10px;
    width: 200px;
    height: 200px;
  }
  h2 {
    width: 100%;
    font-weight: 700;
    font-size: 1.7rem;
    padding: 20px;
    text-align: center;
  }
  p {
    width: 100%;
    padding: 20px;
    text-align: center;
  }
  button {
    display: block;
    background: transparent;
    border: 1px white solid;
    padding: 10px;
    border-radius: 18px;
    width: 80vw;
    margin: 25px auto;
    color: white;
    bottom: 0%;
    font-size: 1.2rem;
    font-weight: 700;
  }
</style>
